import { render, staticRenderFns } from "./SolutionsGallery.vue?vue&type=template&id=a803b970"
import script from "./SolutionsGallery.vue?vue&type=script&lang=js"
export * from "./SolutionsGallery.vue?vue&type=script&lang=js"
import style0 from "./SolutionsGallery.vue?vue&type=style&index=0&id=a803b970&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports